module.exports = __webpack_public_path__ + "img/extended.5465f9c5.png";